import styled from 'styled-components';

export const SubstitutionsPlayersWrapper = styled.div`
  overflow-y: scroll;
`;
